import axios from "axios";
import baseURL from "../config/api";

export const post_VisitorWithGroup = async (data: any) => {
    return await axios({
        url: `${baseURL}visitor/create-with-group`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}


export const post_ConvertVisitorsToFamily = async (groupId: number, visitorIds: number[], token: string) => {
    return await axios({
        url: `${baseURL}visitor/ConvertToFamily`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: {
            groupId,
            visitorIds
        }
    }).then(response => response.data);
}

export const post_Visitor = async (data: any, token: string) => {
    return await axios({
        url: `${baseURL}visitor`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_Visitor = async (data: any, token: string) => {
    return await axios({
        url: `${baseURL}visitor`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_Visitor = async (primaryKey: string, token: string) => {
    return await axios({
        url: `${baseURL}visitor`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const getVisitorPaging = async (groupId: number, page: number, size: number, token: string) => {
    return await getFetch(`visitor/GetVisitorPaging/${groupId},${page},${size}`, token)
}

export const getVisitorSearchPaging = async (groupId: number, search: string, searchType: string, page: number, size: number, token: string) => {
    return await getFetch(`visitor/GetVisitorSearchPaging/${groupId},${encodeURIComponent(search)},${searchType},${page},${size}`, token)
}

export const getVisitorHistories = async (visitorId: number, groupId: number, page: number, size: number, token: string) => {
    return await getFetch(`visitor/GetVisitorHistoriesByVisitorIdPaging/${visitorId},${groupId},${page},${size}`, token)
}

const getFetch = async (url: string, token: string, params = {}) => {
    return await axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params,
    }).then(response => response.data);
}
